export const ANALYTICS_CLICK_EVENTS = {
  transferFaqPrefix: 'Rx - Transfer - FAQ - ',
  transferRxAddAnotherMedication: 'Rx - Transfer Pharmacy - Detail - Add Another Medication',
};

export const ANALYTICS_EVENTS = {
  eligibleForTransfer: 'Eligible for Transfer Rx Prompt',
  hasAnotherRxYes: 'Clicked Rx - Transfer - Prompt - Has Another Rx - Yes Link',
  hasAnotherRxNo: 'Clicked Rx - Transfer - Prompt - Has Another Rx - No Link',
  shouldTransferYes: 'Clicked Rx - Transfer - Prompt - Should Transfer Other Rx - Yes Link',
  shouldTransferNo: 'Clicked Rx - Transfer - Prompt - Should Transfer Other Rx - No Link',
  medicationsTransferRx: 'Clicked Rx - Home - Transfer Rx Link',
  landingPageVersionOneTransferSubmit: 'Submitted Transfer Landing Page 1',
  homePageTransferForm: 'Submitted Home Page Transfer Form',
  homePageGetStartedClick: 'Clicked - Homepage Get Started',
  DoctorLandingPageSubmit: 'Submitted Doctor Landing Page',
  DoctorPageSubmit: 'Submitted Doctor Page',
  openedChat: 'Opened Chat',
  chatMessageSent: 'Sent Message',
  addCreditCardFailure: 'Failed to Add Card',
  processOrderFailure: 'Failed to Place Order',
  loggedInTransferFormSubmit: 'Submit logged in transfer form',
  homepageClickAddAnotherMedication: 'Homepage - Click - Add Another Medication',
  clickNoAllergies: 'Getting Started Form - Click - ‘I don’t have any allergies’',
  faqLinkClickHeader: 'FAQ link - Click - ',
  gettingStartedFormFieldFocusHeader: 'Getting Started Form - Focus - ',
  gettingStartedFormToggleGenderHeader: 'Getting Started Form - Click - ',
  transferFormFieldFocusHeader: 'Transfer Prescription Form - Click - ',
  transferFormSubmit: 'Transfer Prescription Form - Submit',
  createAnAccountClickHeader: 'Create An Account Form - Click - ',
  tellUsMoreFormHeader: 'Tell Us More Form - Click - ',
  stayInTouchFormFocusHeader: 'Stay in touch Form -  Focus - ',
  stayInTouchFormSubmit: 'Stay in touch Form - Submit',
  introduceDoctorFormFocusHeader: 'Introduce Us to Doctor Form - Focus - ',
  introduceDoctorFormSubmit: 'Introduce Us to Doctor Form - Submit',
  howItWorksPageHowCapsuleWorksClick: 'Clicked How It Works Page - How Capsule Works',

  headerGetStartedClicked: 'Header - Get Started - Clicked',
  sideMenuSwitchNowClicked: 'Side Menu - Switch Now - Clicked',

  faqPrefix: 'Click FAQ - ',
  homepageFAQClickHeader: 'Clicked Homepage FAQ - ',
  videoPlayPrefix: 'Played Video - ',
  addressChangePrefix: 'Account - ',
  homePageLinkClickPrefix: 'Clicked Home Page - ',

  /** event for external links*/
  externalLinkClicked: 'External Link Clicked',

  /** Events for loggedIn -> Prescriptions */
  /**
   * @deprecated
   */
  medicationAddedToCart: 'Medication Added To Cart',
  /**
   * @deprecated
   */
  medicationRemovedFromCart: 'Medication Removed From Cart',

  /** Events for loggedIn -> Checkout */
  addressListClicked: 'Address List Clicked',
  paymentListClicked: 'Payment List Clicked',
  deliveryWindowsListClicked: 'Delivery Windows List Clicked',
  signatureRequirementChecked: 'Signature Requirement ',

  /** @deprecated 11-27-2019 */
  toolTipClicked: 'Tooltip Clicked',
  placeOrderButtonClicked: 'Place Order Button Clicked',

  /** Events for checkout -> Order Status */
  orderStatusAcknowledged: 'Order Status Acknowledged',

  /** @deprecated 11-27-2019 */
  fieldFocused: 'Field Focused',

  /** User clicked get button on Smart Banner in order to download app */
  showSmartBanner: 'Smart Banner for app download shown to user',
  /** User clicked get button on Smart Banner in order to download app */
  clickGetSmartBanner: 'User clicked call-to-action button on Smart Banner',
  /** User clicked close button on Smart Banner */
  clickCloseSmartBanner: 'User clicked close button on Smart Banner',
  /** Smart Banner closes */
  closeSmartBanner: 'Smart Banner closes',

  controlMedicationInfoBannerDisplayed: 'Control Medication Info Banner Displayed - ',

  addInsurance: 'Account - View Add Insurance',

  /** @deprecated 11-27-2019 */
  addInsuranceTooltipClick: 'Tooltip Clicked',

  addInsuranceFrontCardUpload: 'Account - Add Front of Card',

  addInsuranceBackCardUpload: 'Account - Add Back of Card',

  deleteViewInsurance: 'Account - View Delete Insurance',

  deleteSuccesfulInsurance: 'Account - Delete Insurance Successful',

  successfulInsuranceUpload: 'Account - Submit Insurance Successful',

  unsuccessfulInsuranceUpload: 'Account - Add Insurance Failed',

  downloadFsaReceipt: 'Download FSA Receipt',
};

/**
 * Nov 15, 2019
 *
 * These are Segment TRACK event names, that are identical
 * across platforms: Web | iOS | Android | etc.
 *
 * @see https://docs.google.com/spreadsheets/d/1I7TPIpMh6i33QbLquR2nv_quP10TIm9yDS_-_ls892I/edit#gid=1078805065
 */
export const UNIFIED = {
  error: {
    name: 'Error',
    properties: [
      /** Insurance Failed, Chat Failed, Credit Card failed, etc. */
      'errorMessage',

      /** More specific details, such as: "Phone number was invalid." */
      'errorSummary',

      /** The API responsible for the error. */
      'api',

      /** If API response error, the HTTP response */
      'errorCode',

      /** The URL where the error appeared */
      'source',
    ],
  },
  addACreditCard: {
    name: 'Add a Credit Card',
    properties: [],
  },
  submitInsurance: {
    name: 'Submit Insurance',
    properties: [],
  },
  insuranceSuccessful: {
    name: 'Insurance Successful',
    properties: [],
  },
  insuranceFailed: {
    name: 'Insurance Failed',
    properties: [],
  },
  addAnotherTransferMedication: {
    name: 'Add Another Tansfer Medication',
    properties: [],
  },
  addDeliveryAddress: {
    name: 'Add Delivery Address',
    properties: ['location'],
  },
  addFamilyMember: {
    name: 'Add Family Member',
    properties: ['source'],
  },
  addFamilyMemberFailed: {
    name: 'Add Family Member Failed',
    properties: ['source', 'error_code', 'error_summary'],
  },
  addBackOfInsuranceCard: {
    name: 'Add Back of Insurance Card',
    properties: [],
  },
  addFrontOfInsuranceCard: {
    name: 'Add Front of Insurance Card',
    properties: [],
  },
  addOnboardingFormOtherMedication: {
    name: 'Add Onboarding Form Other Medication',
    properties: ['medication_id'],
  },
  addToCart: {
    name: 'Add to Cart',
    properties: [
      'page', // medications, essentials, add_ons, cart_list
      'patientmedication_id',
      'prescription_fulfillment_id',
      'price',
      'display_name_primary',
      'dosage',
      'OTC',
      'quantity',
      'position', // [row: 1-indexed number, column: 1-indexed number]
    ],
  },
  addToFirstRxCart: {
    name: 'Add to First Rx Cart',
    properties: [],
  },
  appAdoptionView: {
    name: 'View Capsule App Web Page',
    properties: [],
  },
  appAdoptionOpenInApp: {
    name: 'Select Checkout in App',
    properties: [],
  },
  appAdoptionStayOnWeb: {
    name: 'Select Stay on Web',
    properties: [],
  },
  appWebPageEligible: {
    name: 'App Web Page Eligible',
    properties: [],
  },
  archiveMedication: {
    name: 'Archive Medication',
    properties: ['source', 'is_expired', 'medication_id', 'patientmedication_id'],
  },
  beginCheckout: {
    name: 'Begin Checkout',
    properties: [],
  },
  beginOnboarding: {
    name: 'Begin Onboarding',
    properties: ['pagepath', 'source'],
  },
  captchaFailed: {
    name: 'Captcha Failed',
    properties: ['type'],
  },
  captchaSuccessful: {
    name: 'Captcha Successful',
    properties: ['type'],
  },
  closeArchiveMedicationFeedback: {
    name: 'Close Archive Medication Feedback',
    properties: ['patientmedication_id'],
  },
  closeChat: {
    name: 'Close Chat',
    properties: ['websocket_state'],
  },
  closeMfaModal: {
    name: 'Close MFA Modal',
    properties: [],
  },
  collapseFamilyMemberMeds: {
    name: 'Collapse Family Member Meds',
    properties: ['location', 'patient_id', 'is_primary'],
  },
  contactUsCallOrText: {
    name: 'Contact Us Call or Text',
    properties: ['openedFrom'],
  },
  copyCapsulePharmacyAddress: {
    name: 'Copy Capsule Pharmacy Address',
    properties: ['pagepath'],
  },
  createAccount: {
    name: 'Create Account',
    properties: [],
  },
  createEligibleLead: {
    name: 'Create Eligible Lead',
    properties: [],
  },
  createLead: {
    name: 'Create Lead',
    properties: [],
  },
  createWaitlistLead: {
    name: 'Create Waitlist Lead',
    properties: [],
  },
  deleteCreditCard: {
    name: 'Delete Credit Card',
    properties: ['source'],
  },
  deleteDeliveryAddress: {
    name: 'Delete Delivery Address',
    properties: ['location'],
  },
  deleteSuccesfulInsurance: {
    name: 'Account - Delete Insurance Successful',
    properties: [],
  },
  deleteViewInsurance: {
    name: 'Account - View Delete Insurance',
    properties: [],
  },
  deliveryAreaEligibilityZipcodeFailed: {
    name: 'Delivery Area Eligibility Zipcode Failed',
    properties: ['zipcode', 'pagepath'],
  },
  deliveryAreaEligibilityZipcodeSuccessful: {
    name: 'Delivery Area Eligibility Zipcode Successful',
    properties: ['zipcode', 'pagepath'],
  },
  deliveryRescheduleFailed: {
    name: 'Delivery Reschedule Failed',
    properties: ['error_code', 'error_summary', 'order_id'],
  },
  deliveryRescheduleSuccessful: {
    name: 'Delivery Reschedule Successful',
    properties: ['order_id'],
  },
  dismissAdSpace: {
    name: 'Dismiss Ad Space',
    properties: ['ad_location', 'ad_page', 'ad_position', 'ad_action'],
  },
  dismissPostCheckoutModal: {
    name: 'Dismiss Post Checkout Modal',
    properties: [],
  },
  dismissPotentialMedications: {
    name: 'Dismiss Potential Medications',
    properties: [],
  },
  dismissPotentialMedicationsPostCheckoutModal: {
    name: 'Dismiss Potential Medications Post Checkout Modal',
    properties: [],
  },
  downloadsAReceipt: {
    name: 'Downloads a Receipt',
    properties: [],
  },
  editAddressFailed: {
    name: 'Edit Address Failed',
    properties: ['source'],
  },
  editAddressSuccessful: {
    name: 'Edit Address Successful',
    properties: ['source'],
  },
  editDeliveryAddress: {
    name: 'Edit Delivery Address',
    properties: ['zipcode'],
  },
  /**
   * the event should pass if the submitted screen is DIFFERENT than the prior address instructions
   * Example: Even if doorman goes from checked to unchecked, field is pass as TRUE.
   */
  editDeliveryInstructionsSuccessful: {
    name: 'Edit Delivery Instructions Successful',
    properties: [
      'source', // only “Reschedule Delivery Instructions Edit” is currently possible
      'updated_instructions', // true/false
      'updated_doorman', // true/false
      'delivery_address_id',
    ],
  },
  editDeliveryInstructionsFailed: {
    name: 'Edit Delivery Instructions Failed',
    properties: ['error_code', 'error_summary'],
  },
  editTip: {
    name: 'Edit Tip',
    properties: ['starting_value', 'final_value'],
  },
  eligibilityAreaZipcodeGetStarted: {
    name: 'Eligibility Area Zipcode Get Started',
    properties: [],
  },
  eligibleForPostCheckoutModal: {
    name: 'Eligible For Post Checkout Modal',
    properties: ['type'],
  },
  enterNewDoctorName: {
    name: 'Enter New Doctor Name',
    properties: ['pagepath', 'form'],
  },
  exitAppDownloadModal: {
    name: 'Exit App Download Modal',
    properties: ['source'],
  },
  expandEmployeeBenefits: {
    name: 'Expand Employee Benefits',
    properties: [],
  },
  expandFamilyMemberMeds: {
    name: 'Expand Family Member Meds',
    properties: ['location', 'patient_id', 'is_primary'],
  },
  expandFaq: {
    name: 'Expand FAQ',
    properties: ['text'],
  },
  expandFaqModal: {
    name: 'Expand Onboarding Help',
    properties: ['text'],
  },
  expandHomepageFaqs: {
    name: 'Expand Homepage FAQs',
    properties: ['text'],
  },
  expandOTCFaq: {
    name: 'Expand OTC FAQ',
    properties: ['text'],
  },
  expandPromotionalFAQ: {
    name: 'Expand Promotional FAQ',
    properties: ['text', 'promotion_value'],
  },
  expandTransferQuestions: {
    name: 'Expand Transfer Questions',
    properties: ['text'],
  },
  fieldFocused: {
    name: 'Field Focused',
    properties: ['pagepath', 'fieldname'],
  },
  fillMyPrescription: {
    name: 'Fill My Prescription',
    properties: [],
  },
  focusedOnDoctorNameField: {
    name: 'Focused on Doctor Name Field',
    properties: [],
  },
  focusedOnDoctorPhoneField: {
    name: 'Focused on Doctor Phone Field',
    properties: [],
  },
  formIncompleteError: {
    name: 'Form Incomplete Error',
    properties: ['pagepath', 'incomplete_fields_count'],
  },
  joinDeliveryAreaWaitlist: {
    name: 'Join Delivery Area Waitlist',
    properties: ['pagepath'],
  },
  loginFailed: {
    name: 'Login Failed',
    properties: ['error_code', 'error_summary'],
  },
  loginSuccessful: {
    name: 'Login Successful',
    properties: [],
  },
  logoutSuccessful: {
    name: 'Logout Successful',
    properties: ['customer_initiated'],
  },
  mcypEligible: {
    name: 'MCYP Eligible',
    properties: ['is_eligible', 'has_ready_to_check_out_meds'],
  },
  medicationDetailFailed: {
    name: 'Medication Detail Failed',
    properties: ['prescriptionId', 'error_code', 'error_summary'],
  },
  medicationDirectionClosed: {
    name: 'Medication Directions Closed',
    properties: [],
  },
  modalCategoryScroll: {
    name: 'Modal Category Scroll', // Checkout Addons Page
    properties: [
      'horizontal_scroll', // boolean
      'category', // string
      'carousel', // null | 'dot' | 'left' | 'right'
    ],
  },
  moveExistingMedication: {
    name: 'Move Existing Medication',
    properties: [],
  },
  onfleetUsed: {
    name: 'Open OnFleet Through SMS',
    properties: [],
  },
  openChat: {
    name: 'Open Chat',
    properties: ['source', 'has_unread_message'],
  },
  openMedicationAction: {
    name: 'Open Medication Action',
    properties: ['patientmedication_id'],
  },
  orderFailed: {
    name: 'Order Failed',
    properties: [
      'first_time_order',
      'cart_id',
      'prescription_fulfillment_ids',
      'patientmedication_ids',
      'error_code',
      'error_summary',
      'has_dependents',
    ],
  },
  orderSuccessful: {
    name: 'Order Successful',
    properties: [
      'first_time_order',
      'cart_id',
      'order_id',
      'prescription_fulfillment_ids',
      'patientmedication_ids',
      'subtotal',
      'tip_amount',
      'total',
      'has_dependents',
      'item_count',
      'otc_count',
    ],
  },
  placeFirstRxOrder: {
    name: 'Place First Rx Order',
    properties: [],
  },
  playVideo: {
    name: 'Play Video',
    properties: ['video_title', 'time'],
  },
  removeFromCart: {
    name: 'Remove from Cart',
    properties: [
      'page', // medications, essentials, add_ons, cart_list
      'patientmedication_id',
      'prescription_fulfillment_id',
      'price',
      'display_name_primary',
      'dosage',
      'OTC',
      'quantity',
    ],
  },
  requestPasswordFailed: {
    name: 'Request Password Failed',
    properties: [],
  },
  requestPasswordReset: {
    name: 'Request Password Reset',
    properties: [],
  },
  requestPasswordSuccessful: {
    name: 'Request Password Successful',
    properties: [],
  },
  requestRefillModalClosed: {
    name: 'Request Refill Modal Closed',
    properties: [],
  },
  resendVerificationCode: {
    name: 'Resend Verification Code',
    properties: ['channel'],
  },
  resetPasswordFailed: {
    name: 'Reset Password Failed',
    properties: [],
  },
  resetPasswordSuccessful: {
    name: 'Reset Password Successful',
    properties: [],
  },
  rxLiveUnavailableForTransfer: {
    name: 'RX Live Unavailable For Transfer',
    properties: [],
  },
  saveCheckoutAllergyProfile: {
    name: 'Save Checkout Allergy Profile',
    properties: [
      'allergies',
      'allergiesToggle',
      'conditions',
      'conditionsToggle',
      'medications',
      'medicationsToggle',
      'doctors',
    ],
  },
  saveCheckoutOtherMedicationsDetails: {
    name: 'Save Checkout Other Medications Details',
    properties: ['medications', 'num_medications_shown', 'perc_medications_selected'],
  },
  saveCheckoutOtherMedicationsProfile: {
    name: 'Save Checkout Other Medications Profile',
    properties: ['medicationsToggle'],
  },
  saveNewAddress: {
    name: 'Save New Address',
    properties: [],
  },
  scrollReviews: {
    name: 'Scroll Homepage Reviews',
    properties: [],
  },
  search: {
    name: 'Search',
    properties: ['page', 'search_term'],
  },
  selectAllMeds: {
    name: 'Select transfer all meds',
    properties: [],
  },
  selectAddChatAttachment: {
    name: 'Select Add Chat Attachment',
    properties: [''],
  },
  selectAddNewDoctor: {
    name: 'Select Add Another Doctor',
    properties: ['pagepath', 'form'],
  },
  selectAdSpace: {
    name: 'Select Ad Space',
    properties: ['ad_location', 'ad_page', 'ad_position', 'ad_action'],
  },
  selectAnotherAppointmentTime: {
    name: 'Select Another Appointment Time',
    properties: [],
  },
  selectAppDownloadModal: {
    name: 'Select App Download Modal',
    properties: ['source'],
  },
  selectAppointmentWindow: {
    name: 'Select Appointment Window',
    properties: ['window'],
  },
  selectAutocompleteAddress: {
    name: 'Select Autocomplete Address',
    properties: [],
  },
  selectBannerCTA: {
    name: 'Select Banner CTA',
    properties: ['banner_action', 'banner_location', 'banner_page', 'flow_triggered'],
  },
  selectChatErrorAction: {
    name: 'Select Chat Error Action',
    properties: ['type'],
  },
  selectCheckoutMedicalProfileToggle: {
    name: 'Select Checkout Medical Profile Toggle',
    properties: ['field', 'value'],
  },
  selectDeliveryMethod: {
    name: 'Select Delivery Method',
    properties: ['delivery_method'],
  },
  selectDeliveryWindow: {
    name: 'Select Delivery Window',
    properties: ['selected_date', 'cart_id', 'first_time_order', 'selected_window'],
  },
  selectDoctorSentRx: {
    name: 'Select Doctor Sent Rx',
    properties: [],
  },
  selectDoNotTransferMedicationPOTS: {
    name: 'Select Do Not Transfer Medication (POTs MCYP)',
    properties: [],
  },
  selectEssentialsCategory: {
    name: 'Select Essentials Category',
    properties: ['aisle', 'source'],
  },
  selectExistingUserSignIn: {
    name: 'Select Existing User Sign In',
    properties: ['partnership'],
  },
  selectLocationAddress: {
    name: 'Select Location Address',
    properties: ['location'],
  },
  selectLocationPhone: {
    name: 'Select Location Phone',
    properties: ['location'],
  },
  selectLoggedInTransferFormUser: {
    name: 'Select Logged In Transfer Form User',
    properties: ['account_holder'],
  },
  selectMCYPMoreDetails: {
    name: 'Select Post Order More Details',
    properties: [],
  },
  selectNotDoormanAddress: {
    name: 'Select Not Doorman Address',
    properties: ['delivery_address_id'],
  },
  selectOnboardingAddDoctorInfo: {
    name: 'Select Onboarding Add Doctor Info',
    properties: [],
  },
  selectOTCSignup: {
    name: 'Select OTC Signup Sticky Button',
    properties: [],
  },
  selectPharmacyInfo: {
    name: 'Select Pharmacy Info',
    properties: ['selected_from', 'pagepath'],
  },
  selectPickupLocation: {
    name: 'Select Pickup Location',
    properties: [],
  },
  selectPostCheckoutCta: {
    name: 'Select Post Checkout CTA',
    properties: [],
  },
  selectPostCheckoutModal: {
    name: 'Select Post Checkout Modal',
    properties: ['type'],
  },
  selectReschedule: {
    name: 'Select Reschedule',
    properties: ['source'],
  },
  selectRescheduleDeliveryWindow: {
    name: 'Select Reschedule Delivery Window',
    properties: ['source', 'order_id', 'selected_date', 'selected_window'],
  },
  selectRxAtPharmacy: {
    name: 'Select Rx At Pharmacy',
    properties: [],
  },
  selectRxWithDoctor: {
    name: 'Select Rx With Doctor',
    properties: [],
  },
  selectSex: {
    name: 'Select Sex',
    properties: ['pagepath', 'sex'],
  },
  selectTransferFormDoctorName: {
    name: 'Select Transfer Form Doctor Name',
    properties: ['pagepath', 'form'],
  },
  /**
   * The user has clicked a medication name in the dropdown of the transfer form. If the medication
   * is ineligible (event property = ineligible_med), then we render that selected med in a box
   * with a notice that they'll need to ask their doctor to transfer that med. They can continue
   * the flow, but our back end will never know of that med.
   * @see https://docs.google.com/spreadsheets/d/1OpBk_EDE4n7ZGndR_0hGM6Nxf2oVMgUnXzKO4q4R0Ro/edit#gid=0
   */
  selectTransferMedication: {
    name: 'Select Transfer Medication',
    properties: ['medication_name', 'eligible'],
  },
  selectTransferMedsPOTS: {
    name: 'Select Transfer Meds (POTs MCYP)',
    properties: [],
  },
  selectTransferPharmacyInfo: {
    name: 'Select Transfer Pharmacy Info',
    properties: ['selected_from', 'pagepath'],
  },
  sendChat: {
    name: 'Send Chat',
    properties: ['source', 'autopopulated'],
  },
  sendChatFailed: {
    name: 'Send Chat Failed',
    properties: ['error_code', 'error_summary'],
  },
  shareCapsuleWithDoctor: {
    name: 'Select Share Capsule With Doctor',
    properties: ['pagepath'],
  },
  showCapsuleInfo: {
    name: 'Show Capsule Info',
    properties: [],
  },
  signInCodeProvided: {
    name: 'Sign In Code Provided',
    properties: [],
  },
  signUpFailed: {
    name: 'Sign Up Failed',
    properties: ['error_code', 'error_summary'],
  },
  signUpSubmitted: {
    name: 'Sign Up Submitted',
    properties: [],
  },
  signUpSuccessful: {
    name: 'Sign Up Successful',
    properties: [],
  },
  skipForNow: {
    name: 'Skip For Now',
    properties: ['pagepath', 'source'],
  },
  skipPharmacyTransfer: {
    name: 'Skip Pharmacy Transfer',
    properties: ['pagepath'],
  },
  skipTransferForm: {
    name: 'Skip Transfer Form',
    properties: ['pagepath'],
  },
  sortActivePrescriptions: {
    name: 'Sort Active Prescriptions',
    properties: ['sort_by'],
  },
  stopVideo: {
    name: 'Stop Video',
    properties: ['video_title', 'time'],
  },
  submitArchiveMedicationFeedback: {
    name: 'Submit Archive Medication Feedback',
    properties: ['Response', 'Freeform'],
  },
  submitBirthdate: {
    name: 'Submit Birthdate',
    properties: [],
  },
  /**
   * the event should pass if the submitted screen is DIFFERENT than the prior address instructions
   * Example: Even if doorman goes from checked to unchecked, field is pass as TRUE.
   */
  submitDeliveryInstructionsEdit: {
    name: 'Submit Delivery Instructions Edit',
    properties: [
      'source', // only “Reschedule Delivery Instructions Edit” is currently possible
      'updated_instructions', // true/false
      'updated_doorman', // true/false
      'delivery_address_id',
    ],
  },
  submitDeliveryReschedule: {
    name: 'Submit Delivery Reschedule',
    properties: ['order_id', 'delivery_address_id'],
  },
  submitFirstTransfer: {
    name: 'Submit First Transfer',
    properties: [],
  },
  submitLoggedInTransfer: {
    name: 'Submit Logged In Transfer',
    properties: [],
  },
  submitOnboarding: {
    name: 'Submit Onboarding',
    properties: ['pagepath', 'contains_control', 'flow'],
  },
  submitOnboardingMedication: {
    name: 'Submit Onboarding Medication',
    properties: ['medication_names', 'contains_control', 'selected_from_list', 'all_meds'],
  },
  submitOnboardingTransfer: {
    name: 'Submit Onboarding Transfer',
    properties: [],
  },
  submitOrder: {
    name: 'Submit Order',
    properties: [
      'display_name_primary', // for this, it's Array<string>
      'first_time_order',
      'cart_id',
      'order_id',
      'prescription_fulfillment_ids',
      'patientmedication_ids',
      'subtotal',
      'has_dependents',
      'otc_count',
      'item_count',
      'delivery_method',
      'tip_amount',
      'total',
    ],
  },
  submitOTCPromoSignup: {
    name: 'Submit OTC Promo Signup',
    properties: ['promotion_value'],
  },
  submitPhotoId: {
    name: 'Submit Photo ID',
    properties: [],
  },
  submitPromoSignup: {
    name: 'Submit Promotional Signup',
    properties: ['promotion_value'],
  },
  submitResendEmail: {
    name: 'Submit Resend Email',
    properties: [],
  },
  submitTransfer: {
    name: 'Submit Transfer',
    properties: ['medication_names', 'page'],
  },
  submitTransferMedication: {
    name: 'Submit Transfer Medication',
    properties: [
      'medication_name',
      'state',
      'contains_control',
      'selected_from_list',
      'all_meds',
      'source',
      'num_medications_shown',
      'perc_medications_selected',
      'perc_eligible_medications_selected',
    ],
  },
  submitTransferPotentialMedications: {
    name: 'Submit Transfer Potential Medications',
    properties: ['number_requested', 'transfer_requested'],
  },
  submitUpdatedPhoneNumber: {
    name: 'Submit Updated Phone Number',
    properties: [],
  },
  submitUpdatedPhoneNumberFailed: {
    name: 'Submit Updated Phone Number Failed',
    properties: ['error_code', 'error_summary'],
  },
  submitUpdatedPhoneNumberSuccess: {
    name: 'Submit Updated Phone Number Successful',
    properties: [],
  },
  submitVerificationCode: {
    name: 'Submit Verification Code',
    properties: [],
  },
  submitVerificationCodeFailed: {
    name: 'Submit Verification Code Failed',
    properties: ['error_code', 'error_summary'],
  },
  submitVerificationCodeSuccessful: {
    name: 'Submit Verification Code Successful',
    properties: [],
  },
  submitVerifyPartnershipEmail: {
    name: 'Submit Verify Partnership Email',
    properties: ['partnership'],
  },
  transferFailed: {
    name: 'Transfer Failed',
    properties: ['error_code', 'error_summary', 'page'],
  },
  transferSuccessful: {
    name: 'Transfer Successful',
    properties: ['medication_names', 'page', 'type', 'account_holder'],
  },
  unarchiveMedication: {
    name: 'Unarchive Medication',
    properties: ['source', 'is_expired', 'medication_id', 'patientmedication_id'],
  },
  undoAction: {
    name: 'Undo Action',
    properties: [],
  },
  viewAboutUs: {
    name: 'View About Us',
    properties: ['source'],
  },
  viewAddAddress: {
    name: 'View Add Address',
    properties: ['source'],
  },
  viewAddCreditCard: {
    name: 'View Add Credit Card',
    properties: ['source'],
  },
  viewAddFamilyMember: {
    name: 'View Add Family Member',
    properties: ['source'],
  },
  viewAddFamilyMemberConfirmation: {
    name: 'View Add Family Member Confirmation',
    properties: [],
  },
  viewAddInsurance: {
    name: 'View Add Insurance',
    properties: ['source'],
  },
  viewAddPayment: {
    name: 'View Add Payment',
    properties: ['cart_id', 'first_time_order'],
  },
  viewAddPhotoId: {
    name: 'View Add Photo ID',
    properties: [],
  },
  viewAddressValidation: {
    name: 'View Address Validation',
    properties: [],
  },
  viewAdSpace: {
    name: 'View Ad Space',
    properties: ['ad_location', 'ad_page', 'ad_position', 'ad_action'],
  },
  viewAllergyQuestion: {
    name: 'View Allergy Question',
    properties: [],
  },
  viewAppDownloadModal: {
    name: 'View App Download Modal',
    properties: ['source'],
  },
  viewAppointmentUnavailable: {
    name: 'View Appointment Unavailable',
    properties: ['error_status_code'],
  },
  viewArchivedMedications: {
    name: 'View Archived Medications',
    properties: ['source'],
  },
  viewArchiveMedicationRationale: {
    name: 'View Archive Medication Rationale',
    properties: [],
  },
  /**
   * The user viewed the "ask your doctor" box
   * @see https://docs.google.com/spreadsheets/d/1OpBk_EDE4n7ZGndR_0hGM6Nxf2oVMgUnXzKO4q4R0Ro/edit#gid=0
   */
  viewAskYourDoctorBox: {
    name: 'View Ask Your Doctor Box',
    properties: ['medication_names'],
  },
  /**
   * The user viewed the full page "ask your doctor" screen when they only add ineligible
   * controlled meds in the previous step.
   * @see https://docs.google.com/spreadsheets/d/1OpBk_EDE4n7ZGndR_0hGM6Nxf2oVMgUnXzKO4q4R0Ro/edit#gid=0
   */
  viewAskYourDoctorScreen: {
    name: 'View Ask Your Doctor Screen',
    properties: ['medication_names'],
  },
  viewBanner: {
    name: 'View Banner',
    properties: ['banner_action', 'banner_location', 'banner_page', 'flow_triggered'],
  },
  viewBlog: {
    name: 'View Blog',
    properties: [],
  },
  viewCart: {
    name: 'View Cart',
    properties: ['item_count', 'otc_count', 'subtotal', 'tip_amount', 'total'],
  },
  viewChatPrompt: {
    name: 'View Chat Prompt',
    properties: ['source'],
  },
  viewCheckout: {
    name: 'View Checkout',
    properties: [
      'first_time_order',
      'patientmedication_ids',
      'subtotal',
      'tip_amount',
      'total',
      'cart_id',
      'has_dependents',
    ],
  },
  viewCheckoutAddOns: {
    name: 'View Checkout Add-Ons',
    properties: [
      'otc_count', // number
    ],
  },
  viewCheckoutAllergyProfile: {
    name: 'View Checkout Allergy Profile',
    properties: [],
  },
  viewCheckoutDeliveryAddress: {
    name: 'View Checkout Delivery Address',
    properties: ['cart_id', 'first_time_order'],
  },
  viewCheckoutDeliveryWindow: {
    name: 'View Checkout Delivery Window',
    properties: [
      'selected_date',
      'selected_window',
      'cart_id',
      'same_day_availability',
      'windows_available_count',
      'first_time_order',
      'earliest_window',
    ],
  },
  viewCheckoutOtherMedications: {
    name: 'View Checkout Other Medications',
    properties: [],
  },
  viewCheckoutOtherMedicationsDetails: {
    name: 'View Checkout Other Medications Details',
    properties: [],
  },
  viewCheckYourEmail: {
    name: 'View Check Your Email',
    properties: ['transfer_submitted'],
  },
  viewContactUs: {
    name: 'View Contact Us',
    properties: [],
  },
  viewDeliveryAreaEligibilityForm: {
    name: 'View Delivery Area Eligibility Form',
    properties: ['pathname'],
  },
  viewDeliveryMethod: {
    name: 'View Delivery Method',
    properties: ['available_delivery_methods'],
  },
  viewDoormanConfirmation: {
    name: 'View Doorman Confirmation',
    properties: ['delivery_address_id'],
  },
  viewEditExistingAddress: {
    name: 'View Edit Existing Address',
    properties: ['source'],
  },
  viewEmployeeBenefits: {
    name: 'View Employee Benefits',
    properties: [],
  },
  viewEssentials: {
    name: 'View Essentials',
    properties: [],
  },
  viewEssentialsCategory: {
    name: 'View Essentials Category',
    properties: ['aisle'],
  },
  viewEssentialsImage: {
    name: 'View Essentials Image',
    properties: ['display_name_primary'],
  },
  viewExperienceABetterPharmacy: {
    name: 'View Experience A Better Pharmacy',
    properties: [],
  },
  viewExpiredCheckoutLink: {
    name: 'View Expired Checkout Link',
    properties: [],
  },
  viewFailedAddressDeliveryInstructions: {
    name: 'View Failed Address Delivery Instructions',
    properties: [],
  },
  viewFailedDeliveryReschedule: {
    name: 'View Failed Delivery Reschedule',
    properties: ['source', 'order_id'],
  },
  viewFaqModal: {
    name: 'View Onboarding Help',
    properties: ['pagepath'],
  },
  viewFaqPage: {
    name: 'View FAQ',
    properties: ['source'],
  },
  viewFaqSection: {
    name: 'View FAQ Section',
    properties: ['source'],
  },
  viewForDoctors: {
    name: 'View For Doctors',
    properties: ['source'],
  },
  viewForgotPassword: {
    name: 'View Forgot Password',
    properties: [],
  },
  viewHome: {
    name: 'View Home',
    properties: [],
  },
  viewHomescreenAppDownloadInterstitial: {
    name: 'View Home Screen App Download Interstitial',
    properties: [],
  },
  viewHowCapsuleWorks: {
    name: 'View How Capsule Works',
    properties: [],
  },
  viewHowToPage: {
    name: 'View Doctor Channel Education Landing Page',
    properties: ['source'],
  },
  viewInsuranceRedirectPage: {
    name: 'View Insurance Redirect Page',
    properties: [],
  },
  viewLearnMore: {
    name: 'View Onboarding Education',
    properties: ['pagepath'],
  },
  viewLocations: {
    name: 'View Locations',
    properties: [],
  },
  viewLoggedInConfirmation: {
    name: 'View Logged In Confirmation',
    properties: [],
  },
  viewLoggedInDoctorInfo: {
    name: 'View Logged In Doctor Info',
    properties: [],
  },
  viewLoggedInPharmacyInfo: {
    name: 'View Logged In Pharmacy Info',
    properties: [],
  },
  viewLoggedInRxAtPharmacy: {
    name: 'View Logged In Rx At Pharmacy',
    properties: [],
  },
  viewLoggedInRxFromDoctor: {
    name: 'View Logged In Rx From Doctor',
    properties: [],
  },
  viewLoggedInRxInfo: {
    name: 'View Logged In Rx Info',
    properties: [],
  },
  viewLoggedInTextConfirmation: {
    name: 'View Logged In Text Confirmation',
    properties: [],
  },
  viewLoggedInTransferForm: {
    name: 'View Logged In Transfer Form',
    properties: ['pagepath', 'form_type', 'pending_requests'],
  },
  viewLogin: {
    name: 'View Login',
    properties: [],
  },
  viewLoginVerification: {
    name: 'View Login Verification',
    properties: [],
  },
  viewManagePayment: {
    name: 'View Manage Payments',
    properties: ['source'],
  },
  viewMCYPExperienceIsEligible: {
    name: 'Post Order MCYP Eligible',
    properties: [],
  },
  viewMedicalConditionsQuestion: {
    name: 'View Medical Conditions Question',
    properties: [],
  },
  viewMedicationDetails: {
    name: 'View Medication Details',
    properties: ['is_archived', 'patient_medications_id'],
  },
  viewMedicationGuide: {
    name: 'View Medication Guide',
    properties: ['source'],
  },
  viewMedications: {
    name: 'View Medications',
    properties: [
      'ready_to_check_out_count',
      'has_dependents',
      'pending_requests',
      'available_actions',
      'patient_medications_id',
      'active_medications',
      'potential_transfers',
    ],
  },
  viewMfaModal: {
    name: 'View MFA Modal',
    properties: [],
  },
  viewNavbar: {
    name: 'View Nav Bar',
    properties: ['pagepath', 'is_logged_in'],
  },
  viewNoAvailableAppointments: {
    name: 'View No Available Appointments',
    properties: [],
  },
  viewOlderChatsUnavialable: {
    name: 'View Older Chats Unavailable',
    properties: [],
  },
  viewOnboardingAboutYou: {
    name: 'View Onboarding About You',
    properties: ['flow'],
  },
  viewOnboardingConfirmation: {
    name: 'View Onboarding Confirmation',
    properties: ['confirmation_type'],
  },
  viewOnboardingContactInfo: {
    name: 'View Onboarding Contact Info',
    properties: ['contact_type'],
  },
  viewOnboardingDeliveryAreaEligibilityForm: {
    name: 'View Onboarding Delivery Area Eligibility Form',
    properties: [],
  },
  viewOnboardingDoctorInfo: {
    name: 'View Onboarding Doctor Info',
    properties: [],
  },
  viewOnboardingEligibilityConfirmation: {
    name: 'View Onboarding Delivery Eligibility Confirmation',
    properties: [],
  },
  viewPostOrderInlineAppDownloadCta: {
    name: 'View Post-Order in-line App Download CTA',
    properties: [],
  },
  viewPostOrderJustSayCapsule: {
    name: 'View Post Order Just Say Capsule',
    properties: [],
  },
  viewTransferDoctorInfo: {
    name: 'View Transfer Doctor Info',
    properties: [],
  },
  viewVerifyFailedAddress: {
    name: 'View Verify Failed Address',
    properties: ['delivery_address_id'],
  },
  medicationCardHasCta: {
    name: 'Medication Card Has CTA',
    properties: ['patientmedication_ids', 'cta_type', 'cta_variation'],
  },
  selectRequestRefillCta: {
    name: 'Select Request Refill CTA',
    properties: ['source', 'patientmedication_ids', 'cta_variation'],
  },
  selectProcessRefillCta: {
    name: 'Select Process Refill CTA',
    properties: ['source', 'prescription_fulfillment_ids', 'cta_variation'],
  },
  selectPostOrderInlineAppDownloadCta: {
    name: 'Select Post-Order in-line App Download CTA',
    properties: [],
  },
  selectHomescreenAppDownloadInterstitial: {
    name: 'Select Home Screen App Download Interstitial',
    properties: [],
  },
  cancelRequestRefill: {
    name: 'Cancel Request Refill',
    properties: ['source', 'patientmedication_ids', 'cta_variation'],
  },
  createReactiveRetrieval: {
    name: 'Create Reactive Retrieval',
    properties: ['retrieval_ids', 'task_ids', 'automated'],
  },
  cancelProcessRefill: {
    name: 'Cancel Process Refill',
    properties: ['source', 'prescription_fulfillment_ids', 'cta_variation'],
  },
  createManualRefillTask: {
    name: 'Create Manual Refill Task',
    properties: ['task_ids', 'retrieval_ids', 'automated'],
  },
  viewMCYPInterstitial: {
    name: 'View MCYP interstitial',
    properties: ['variant'], // variant = "complete checklist" OR "bring all meds"
  },
  viewNoResultsTransferForm: {
    name: 'View no results transfer form',
    properties: ['input'],
  },
  viewOnboardingPharmacyInfo: {
    name: 'View Onboarding Pharmacy Info',
    properties: ['form_type'],
  },
  viewOnboardingRxAtPharmacy: {
    name: 'View Onboarding Rx At Pharmacy',
    properties: [],
  },
  viewOnboardingRxFromDoctor: {
    name: 'View Onboarding Rx From Doctor',
    properties: [],
  },
  viewOnboardingRxInfo: {
    name: 'View Onboarding Rx Info',
    properties: [],
  },
  viewOnboardingRxIntent: {
    name: 'View Onboarding Rx Intent',
    properties: [],
  },
  viewOnboardingTransferMedicationsPrompt: {
    name: 'View Onboarding Transfer Medications Prompt',
    properties: [],
  },
  viewOnboardingWelcomeBack: {
    name: 'View Onboarding Welcome Back',
    properties: [],
  },
  viewOrder: {
    name: 'View Order',
    properties: ['cart_id', 'order_id', 'prescription_fulfillment_ids', 'subtotal'],
  },
  viewOrderTracking: {
    name: 'View Order Tracking',
    properties: ['order_id', 'order_status', 'source', 'path', 'experiment'],
  },
  viewOrderTrackingCard: {
    name: 'View Order Tracking Card',
    properties: ['card_name'],
  },
  viewOrderTrackingCardTimeViewed: {
    name: 'View Order Tracking Card Time Viewed',
    properties: ['card_name', 'time_viewed'],
  },
  viewOtherMedications: {
    name: 'View Other Medications',
    properties: [],
  },
  viewOtherMedicationsConfirmation: {
    name: 'View Other Medications Confirmation',
    properties: [],
  },
  viewOtherMedicationsEducation: {
    name: 'View Other Medications Education',
    properties: [],
  },
  viewPartnershipEmailVerificationInputPage: {
    name: 'View Partnership Email Verification Input Page',
    properties: ['pagepath', 'partnership'],
  },
  viewPartnershipVerificationConfirmation: {
    name: 'View Partnership Verification Confirmation',
    properties: [],
  },
  viewPickupLocation: {
    name: 'View Pickup Location',
    properties: [],
  },
  viewPostCheckoutContinue: {
    name: 'View Post Checkout Continue',
    properties: [],
  },
  viewPostCheckoutModal: {
    name: 'View Post Checkout Modal',
    properties: ['type'],
  },
  viewPostOrderGetMyMeds: {
    name: 'View Post Order Get My Meds',
    properties: [],
  },
  viewPressSection: {
    name: 'View Press Section',
    properties: [],
  },
  viewPricingSection: {
    name: 'View Pricing Section',
    properties: [],
  },
  viewPromoLandingPage: {
    name: 'View Promotional Landing Page',
    properties: ['promotion_value'],
  },
  viewReCaptchaFallback: {
    name: 'View reCaptcha Fallback',
    properties: [],
  },
  viewReceipt: {
    name: 'View Receipt',
    properties: ['cart_id', 'order_id', 'prescription_fulfillment_ids', 'subtotal'],
  },
  viewRescheduleDeliveryWindow: {
    name: 'View Reschedule Delivery Window',
    properties: [
      'source',
      'order_id',
      'selected_date',
      'selected_window',
      'same_day_availability',
      'windows_available_count',
      'earliest_window',
    ],
  },
  viewResetPassword: {
    name: 'View Reset Password',
    properties: [],
  },
  viewReviewsSection: {
    name: 'View Reviews Section',
    properties: [],
  },
  viewHealthProfileOtherMeds: {
    name: 'View Health Profile Other Meds',
    properties: [
      'medication_names',
      'num_total_medications_shown',
      'num_capsule_meds',
      'num_noncapsule_meds',
      'source',
      'num_total_medications_90_days',
      'num_total_medications_90-180_days',
    ],
  },
  viewHealthProfileAreThereOtherMeds: {
    name: 'View Health Profile Are There Other Meds You Take',
    properties: [],
  },
  viewHealthProfileTransfer: {
    name: 'View Health Profile Transfer',
    properties: [
      'num_capsule_medications',
      'num_eligible_medications',
      'perc_capsule_medications',
      'perc_eligible_medications',
      'num_doctor_ineligible_medications',
      'perc_doctor_ineligible_medications',
      'num_not_fillable_ineligible_medications',
      'perc_not_fillable_ineligible_medications',
    ],
  },
  selectHealthProfileTransferMed: {
    name: 'Select Health Profile Transfer Meds',
    properties: ['eligible', 'medication_name', 'select_all'],
  },
  viewHealthProfileFormConfirmation: {
    name: 'View Health Profile Transfer Confirmation',
    properties: ['type'],
  },
  saveHealthProfile: {
    name: 'Save Health Profile',
    properties: [
      'medications',
      'searched_med',
      'num_total_medications_shown',
      'perc_total_medications_selected',
      'capsule_medications',
      'noncapsule_medications',
      'num_capsule_medications_shown',
      'num_noncapsule_medications_shown',
      'perc_capsule_medications_selected',
      'perc_noncapsule_medications_selected',
    ],
  },
  saveHealthProfileNoMeds: {
    name: 'Save Health Profile No Meds Taken',
    properties: [
      'medications',
      'num_total_medications_shown',
      'capsule_medications',
      'num_capsule_medications_shown',
      'noncapsule_medications',
      'num_noncapsule_medications_shown',
    ],
  },
  submitHealthProfileTransfer: {
    name: 'Submit Health Profile Transfer',
    properties: ['num_total_medications_shown', 'num_eligible_medications_shown', 'perc_eligible_medications_selected'],
  },
  viewHowWeGotYourInformation: {
    name: 'View How Did We Get Your Medication Information',
    properties: [],
  },
  dismissHealthProfileTransfer: {
    name: 'Dismiss Health Profile Transfer',
    proerties: [],
  },
  viewScheduleDelivery: {
    name: 'View Schedule Delivery',
    properties: ['flow'],
  },
  viewShowYourDoctor: {
    name: 'View Show Your Doctor',
    properties: ['source'],
  },
  viewShowYourDoctorCard: {
    name: 'View Show Your Doctor Card',
    properties: ['source'],
  },
  viewShowYourDoctorEducation: {
    name: 'View Show Your Doctor Education',
    properties: ['flow'],
  },
  viewSignUp: {
    name: 'View Sign Up',
    properties: [],
  },
  viewStatusTracker: {
    name: 'View Status Tracker',
    properties: ['patient_medications_id', 'state'],
  },
  viewStatusTrackerDetails: {
    name: 'View Status Tracker Details',
    properties: ['patient_medications_id', 'state'],
  },
  viewTip: {
    name: 'View Tip',
    properties: ['starting_value'],
  },
  viewTooltip: {
    name: 'View Tooltip',
    properties: ['pagepath', 'tip'],
  },
  viewTransferBirthdate: {
    name: 'View Transfer Birthdate',
    properties: [],
  },
  viewTransferConfirmation: {
    name: 'View Transfer Confirmation',
    properties: [],
  },
  viewTransferForm: {
    name: 'View Transfer Form',
    properties: ['location'],
  },
  viewTransferFormMedications: {
    name: 'View transfer form medications',
    properties: [],
  },
  /**
   * The user saw ineligible medications during the search session and went back, closed the
   * screen, or went forward in the flow.
   * @see https://docs.google.com/spreadsheets/d/1OpBk_EDE4n7ZGndR_0hGM6Nxf2oVMgUnXzKO4q4R0Ro/edit#gid=0
   */
  viewTransferIneligibleMeds: {
    name: 'View Transfer Ineligible Meds',
    properties: ['medication_names'],
  },
  ViewTransferPharmacyInfo: {
    name: 'View Transfer Pharmacy Info',
    properties: [],
  },
  viewTransferPharmacyInfo: {
    name: 'View Transfer Rx Info',
    properties: ['form_type'],
  },
  viewTransferRxInfo: {
    name: 'View Transfer Rx Info',
    properties: [],
  },
  viewTransferRxIntent: {
    name: 'View logged in Rx intent',
    properties: [],
  },
  viewVerificationCode: {
    name: 'View Verification Code',
    properties: [],
  },
  viewWelcomeScreen: {
    name: 'View Welcome Screen',
    properties: ['page_number'],
  },
  viewYourAccount: {
    name: 'View Your Account',
    properties: [],
  },
  viewYourOrders: {
    name: 'View Your Orders',
    properties: ['failed_orders'],
  },
  viewZipCheckerPage: {
    name: 'View Zipchecker Page',
    properties: ['promotion_value'],
  },
  viewZipcodeSection: {
    name: 'View Zipcode Section',
    properties: [],
  },
  // Clear Rx
  viewClearRxPrescriptions: {
    name: 'View ClearRx Prescriptions',
    properties: [
      'referral',
      'medication_count',
      'medication_name',
      'provider_npi',
      'provider_name',
      'practice_name',
      'emr_department_name',
      'emr_department_id',
      'language_used',
    ],
  },
  viewClearRxSelectPharmacy: {
    name: 'View ClearRx Select Pharmacy',
    properties: [
      'referral', //adding referral to the event
      'capsule_available',
      'capsule_ineligibility_reason',
      'previously_preferred_pharmacy_name',
      'previously_preferred_pharmacy_address',
      'same_day_availability',
      'provider_npi',
      'provider_name',
      'practice_name',
      'emr_department_name',
      'emr_department_id',
      'language_used',
    ],
  },
  selectClearRxPharmacy: {
    name: 'Select ClearRx Pharmacy',
    properties: [
      'referral',
      'pharmacy_name',
      'pharmacy_address',
      'is_capsule',
      'from_search',
      'provider_npi',
      'provider_name',
      'practice_name',
      'emr_department_name',
      'emr_department_id',
      'language_used',
    ],
  },
  viewClearRxPharmacySelectionConfirmation: {
    name: 'View ClearRx Pharmacy Selection Confirmation',
    properties: [
      'pharmacy_name',
      'pharmacy_address',
      'provider_npi',
      'provider_name',
      'practice_name',
      'emr_department_name',
      'emr_department_id',
      'language_used',
    ],
  },
  viewSearchClearRxPharmacy: {
    name: 'View Search ClearRx Pharmacy',
    properties: [],
  },
} as const;

export type AnalyticsSchema = typeof UNIFIED;

export type AnalyticsEventKey = keyof AnalyticsSchema;

export type UnifiedEvent = ValueOf<AnalyticsSchema>;

export const FACEBOOK_EVENTS = [
  UNIFIED.createAccount,
  ANALYTICS_EVENTS.homePageTransferForm,
  UNIFIED.transferSuccessful,
  UNIFIED.orderSuccessful,
  UNIFIED.addToCart,
  UNIFIED.viewPromoLandingPage,
  UNIFIED.submitOTCPromoSignup,
  UNIFIED.submitPromoSignup,
  UNIFIED.submitOnboarding,
  UNIFIED.createEligibleLead,
  UNIFIED.createWaitlistLead,
  UNIFIED.createLead,
  UNIFIED.submitOnboardingTransfer,
  UNIFIED.submitLoggedInTransfer,
  UNIFIED.submitFirstTransfer,
  UNIFIED.addToFirstRxCart,
  UNIFIED.placeFirstRxOrder,
];

export const TATARI_EVENTS = [
  UNIFIED.createAccount,
  UNIFIED.submitOnboarding,
  UNIFIED.createEligibleLead,
  UNIFIED.createWaitlistLead,
  UNIFIED.createLead,
  UNIFIED.submitOnboardingTransfer,
  UNIFIED.submitLoggedInTransfer,
  UNIFIED.submitFirstTransfer,
  UNIFIED.addToFirstRxCart,
  UNIFIED.placeFirstRxOrder,
];

export const AnalyticSources = {
  rescheduleDelivery: 'reschedule delivery',
  rescheduleDeliveryFailedAddress: 'reschedule delivery failed address',
  rescheduleDeliveryOrders: 'reschedule delivery orders',
  rescheduleDeliveryOrderDetails: 'reschedule delivery order details',
  yourPrescriptions: 'your prescriptions',
  orderDetails: 'order details',
  orders: 'orders',
};

export const FlowTriggered = {
  selfServiceReschedule: 'self-service reschedule',
  chatReschedule: 'chat reschedule',
  failedDelivery: 'failed delivery',
};

export const RefillSources = {
  requestRefillRxTab: 'Request Refill Rx Tab',
  processRefillRxTab: 'Process Refill Rx Tab',
};
